import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Models.
import { AuthInfo, AuthReq } from '../models/authObjects';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private _http: HttpClient,
    private router: Router
  ) {
    let loginInfo = sessionStorage.getItem('userInfo');
    this.loginSubject = new BehaviorSubject<AuthInfo | null>(loginInfo ? JSON.parse(loginInfo) : null);
    this.loginObs = this.loginSubject.asObservable();
  }
  private loginUrl: string = Api.login;
  private mfaUrl: string = Api.mfa;
  private codeVerificationUrl: string = Api.codeVerification;
  private url: string = Api.Auth;

  private token: string | null = sessionStorage.getItem('authToken');
  private loginSubject: BehaviorSubject<AuthInfo | null>;
  public loginObs: Observable<AuthInfo | null>;

  public get loginData(): AuthInfo | null {
    return this.loginSubject.value;
  }

  async login(userName: string, password: string): Promise<any> {
    try {
      const response = await this._http.post(this.loginUrl, { userName, password }).toPromise();
      return response;
    } catch (error) {
      console.error('Error in login:', error);
      throw error;
    }
  }

  public ValidateUser(token: string): Observable<ServerResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  
    return this._http.get<ServerResponse>(`${this.url}/ValidateUser`, { headers });
  }  

  public ValidateToken(token: string): Observable<ServerResponse> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this._http.get<ServerResponse>(`${this.url}/validate-token`, { headers });
  }

  async verifyMfa(userName: string, session: string, mfaCode: string): Promise<any> {
    try {
      const response = await this._http
        .post(this.mfaUrl, { userName, session, mfa: mfaCode })
        .toPromise();
      return response;
    } catch (error) {
      console.error('Error en MFA:', error);
      throw error;
    }
  }

  async verifyCode(cognitocode: string): Promise<any> {
    try {
      const response = await this._http
        .post(this.codeVerificationUrl, { cognitocode: cognitocode })
        .toPromise();
      return response;
    } catch (error) {
      console.error('Error in code verification:', error);
      throw error;
    }
  }

  saveToken(token: string): void {
    this.token = token;
    sessionStorage.setItem('authToken', token);
  }

  saveUserSession(token: string, email: string): void {
    this.token = token;
    sessionStorage.setItem('authToken', token);
    //this._http.get<ServerResponse>(`${this.url}/ValidateToken`);
    const userInfo: AuthInfo = {
      userName: email,
      token: token
    };

    sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
    this.loginSubject.next(userInfo);
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    if (!token) return false;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();

      if (isExpired) {
        this.logout();
        return false;
      }
      return true;
    } catch (error) {
      console.error('Token inválido:', error);
      this.logout();
      return false;
    }
  }

  getToken(): string | null {
    return this.token || sessionStorage.getItem('authToken');
  }

  logout(): void {
    this.token = null;
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('userInfo');
    this.loginSubject.next(null);
    this.router.navigate(['/login']);
  }
}
